<template>
  <div class="register-page">
    <q-form
      @submit="onSubmit"
      @reset="onReset"
      class="login-form"
      v-if="!registrationFormSubmitted"
    >
      <div class="background-img" v-if="!isDefaultEnvironment"></div>

      <h4>Registreer</h4>
      <div class="inputs">
        <div class="name-inputs">
          <q-input
            outlined
            bg-color="white"
            v-model="register.firstName"
            label="Voornaam"
            stack-label
            style="width: 170px"
            lazy-rules
            :rules="requiredFieldRule"
          />
          <q-input
            outlined
            bg-color="white"
            v-model="register.lastName"
            label="Achternaam"
            stack-label
            style="width: 170px"
            lazy-rules
            :rules="requiredFieldRule"
          />
        </div>
        <q-input
          outlined
          bg-color="white"
          v-model="register.organisation"
          label="Organisatie"
          stack-label
          lazy-rules
          :rules="requiredFieldRule"
          :placeholder="
            'Vul hier de organisatienaam in of inwoner als je als inwoner wilt zoeken'
          "
        />
        <q-input
          outlined
          bg-color="white"
          v-model="register.email"
          stack-label
          label="E-mail"
          lazy-rules
          :rules="[
            (val) => !!val || 'Vul een correct emailadres in',
            isValidEmail,
          ]"
        />
        <q-input
          outlined
          bg-color="white"
          v-model="register.confirmEmail"
          label="Emailconfirm"
          stack-label
          lazy-rules
          :rules="[
            (val) => !!val || 'Vul een correct emailadres in',
            isValidEmail,
            isConfirmedEmail,
          ]"
        />
      </div>
      <div class="terms-and-conditions">
        <q-list>
          <q-item>
            <q-item-section>
              <q-item-label style="text-align: left;"
                ><strong>Voorwaarden</strong></q-item-label
              >
              <q-item-label style="text-align: left;" caption class="font-dark">
                We willen u laten weten hoe Vindsubsidies namens
                {{ customerPortalName }} werkt en waarom we uw
                registratiegegevens nodig hebben (al uw persoonlijke
                registratiegegevens staan hierboven vermeld).
                <br />
                (<a
                  href="https://www.vindsubsidies.nl/media/1mtnfbzk/gebruiksvoorwaarden-subsidie-informatiedienst.pdf"
                  >Bekijk gebruiksvoorwaarden</a
                >)
              </q-item-label>

              <q-field
                :model-value="register.terms"
                :rules="[acceptedTerms]"
                borderless
                dense
              >
                <template v-slot:control>
                  <q-checkbox
                    class="q-pt-sm"
                    dense
                    v-model="register.terms"
                    color="primary"
                    label="Ik accepteer de algemene voorwaarden"
                  />
                </template>
              </q-field>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-item-label style="text-align: left;"
                ><strong>Uw persoonlijke informatie</strong></q-item-label
              >
              <q-item-label caption style="text-align: left;" class="font-dark">
                Volgens de nieuwe Algemene Verordening Gegevensbescherming (AVG)
                moet u instemmen met uw gegevens (al uw persoonlijke
                registratiegegevens staan hierboven vermeld) die worden
                opgeslagen en gebruikt om u de diensten van Vindsubsidies namens
                {{ customerPortalName }} aan te bieden. Wij gebruiken deze
                gegevens alleen voor de doeleinden van:
                <ul>
                  <li>Toegang te verschaffen tot deze portal</li>
                  <li>
                    E-mails te versturen met betrekking tot het opnieuw
                    instellen van uw wachtwoord
                  </li>
                  <li>
                    E-mails te versturen met betrekking tot wijzigingen in
                    subsidieregelingen, op basis van het door u opgeslagen
                    bewaarde zoekactie
                  </li>
                  <li>
                    Om uw contactgegevens en site gebruik door te geven aan
                    {{ customerPortalName }}
                  </li>
                </ul>
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-item-label style="text-align: left;"
                ><strong>Toestemming</strong></q-item-label
              >
              <q-field
                :model-value="register.permission"
                :rules="[acceptedPermission]"
                borderless
                dense
              >
                <template v-slot:control>
                  <q-checkbox
                    class="q-pt-sm"
                    dense
                    v-model="register.permission"
                    color="primary"
                    label="Ik stem ermee in dat mijn gegevens gebruikt worden voor de bovengenoemde doeleinden"
                  />
                </template>
              </q-field>
            </q-item-section>
          </q-item>
        </q-list>
      </div>
      <div class="q-pb-md">
        <q-btn
          label="Registreer"
          type="submit"
          color="#0a1f8f"
          style="background:#0a1f8f;"
        />
        <q-btn
          label="Reset"
          type="reset"
          color="primary"
          flat
          class="q-ml-sm"
        />
      </div>
    </q-form>
    <div v-else class="submitted-page">
      <div class="row justify-center align-center">
        <div class="col-6">
          <div class="submit-heading">
            <i class="las la-2x la-check-circle submitted-icon"></i>
            <div class="text-h3 q-pb-xl">Bedankt!</div>
            <label class="submit-label q-pt-md">
              U ontvangt zo spoedig mogelijk een email om uw wachtwoord aan te
              maken. Daarna kunt u direct inloggen in de subsidiedatabase.
              <br /><br />
              Let op: de email wordt verstuurd door onze partner
              Vindsubsidies.nl
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, computed, ref } from 'vue';
import authService from '../services/auth.service';
import store from '../store/index';

export default {
  setup() {
    const registrationFormSubmitted = ref(false);

    const register = reactive({
      firstName: '',
      lastName: '',
      email: '',
      confirmEmail: '',
      organisation: '',
      terms: false,
      permission: false,
    });

    onMounted(async () => {
      await authService.getPortalInfo();
    });

    const customerPortalName = computed({
      get: () => store.state.auth.customerPortalName,
    });

    return {
      register,
      customerPortalName,
      registrationFormSubmitted,
      requiredFieldRule: [
        (val) => (val && val.length > 0) || 'Veld is verplicht!',
      ],
      isValidEmail(val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || 'Ongeldig e-mailadres';
      },

      isConfirmedEmail(val) {
        return val === register.email || 'Emailadressen zijn niet gelijk';
      },
      acceptedTerms(val) {
        return (
          val ||
          'Je dient akkoord te geven op de verwerking van je gegevens en de algemene voorwaarden.'
        );
      },
      acceptedPermission(val) {
        return (
          val ||
          'Je dient akkoord te geven op de verwerking van je gegevens en de algemene voorwaarden.'
        );
      },

      async onSubmit() {
        await authService.register(register);
        registrationFormSubmitted.value = true;
      },

      onReset() {
        register.email = '';
        register.confirmEmail = '';
        register.organisation = '';
        register.firstName = '';
        register.lastName = '';
        register.terms = false;
        register.permission = false;
      },
    };
  },
};
</script>
